define('lib/Podio.Transport',['require','translate','underscore','jquery','lib/prototype/Function.prototype','lib/Podio.Store','lib/Podio.Event','lib/Podio.Config'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/prototype/Function.prototype');

  var podioStore = require('lib/Podio.Store');
  var abortableCache = {};
  var isGlobalAjaxErrorsDisabled = false;
  var podioEvent = require('lib/Podio.Event');
  var podioConfig = require('lib/Podio.Config');

  var eventHandlers = {

    onGlobalAjaxSuccess : function(e, xhr, settings, response) {
      if(typeof response == 'object') {
        if(response.status && response.status == 'redirect') {
          var redirectedToCurrentUrl = response.data.url.split('#')[0] === window.location.href.split('#')[0];
          window.location.href = response.data.url;
          if(redirectedToCurrentUrl) {
            window.location.reload(); // Redirected to the same page, reload
          }
        } else if(response.status && response.status == 'error') {
          if(response.error_propagate && response.message) {
            podioEvent.trigger(podioEvent.Types.onTransportGlobalError, response.message, { sticky: true });
          } else if(response.error_code == 'unavailable' ) {
            triggerGenericError();
          }
        }
      }
    },

    onGlobalAjaxError: function(e, jqXHR, ajaxSettings, thrownError) {
      if(jqXHR.statusText == 'abort' || !jqXHR.getAllResponseHeaders() || isGlobalAjaxErrorsDisabled) {
        // Abort is aborted using .abort(), response headers are empty on navigation
        return;
      }

      if(ajaxSettings.url.indexOf('presence.') > -1) {
        return; // Let's be silent about presence-request faliures
      }

      triggerGenericError();
    },

    onAjaxBeforeSend: function(xhr, request) {
      if (!xhr) {
        return;
      }

      if(request.crossDomain) {
        return;
      }

      xhr.setRequestHeader('X-CSRF-Token', podioConfig.authenticity_token());
    },

    onUnload : function(e) {
      isGlobalAjaxErrorsDisabled = true;
    }

  };

  function triggerGenericError() {
    podioEvent.trigger(podioEvent.Types.onTransportGlobalError, t('Sorry, something went wrong. Please try again. #error'), { sticky: false });
  }

  function onDomReady() {
    $(document).ajaxSuccess(eventHandlers.onGlobalAjaxSuccess);
    $(document).ajaxError(eventHandlers.onGlobalAjaxError);
  }

  function requestFromElement(elmTarget, callback) {
    var method      = elmTarget.attr('data-method') || 'GET';
    var url         = elmTarget.attr('href') || elmTarget.attr('action') || elmTarget.data('url');
    var dataType    = elmTarget.attr('data-type');
    var requestData = elmTarget.is('form') ? elmTarget.serializeArray() : {};
    if (elmTarget.hasClass('faux-form')) {
      requestData = elmTarget.find('input,textarea').serializeArray();
    }

    if (_.isUndefined(url) || !url.length) {
      return false;
    }

    request(method, dataType, url, { 'requestData': requestData }, callback);
  }

  function request(method, dataType, url, options, callback) {
    options = options || {};

    var requestParams = {
      dataType: dataType,
      type: method,
      url: url,
      data: options.requestData,
      dataFilter : options.dataFilter,
      success: callback,
      error: _.isFunction(options.errorHandler) ? options.errorHandler : $.noop
    };

    if (options.ajaxParams) {
      _.extend(requestParams, options.ajaxParams);
    }

    if (!options.abortable) {

      return ajax(requestParams);

    } else {

      // Abort previously running ajax request if exists and has the correct readyState.
      var previousXHR = abortableCache[url];
      if (previousXHR && previousXHR.readyState >= 1 && previousXHR.readyState <= 3) {
          previousXHR.abort();
      }
      abortableCache[url] = ajax(requestParams);
      return abortableCache[url];
    }
  }

  function cachedRequest(method, dataType, url, options, callback) {

    var storeKey = options.storeKey;
    var requestKey = options.requestKey;
    var req = $.Deferred();

    var dataStore = podioStore.create(storeKey);
    var cachedData = dataStore.get(requestKey);

    var onDataReceivedFilter = function(data, type) {
      if(type === 'json') {
        dataStore.store(requestKey, JSON.parse(data));
      } else {
        dataStore.store(requestKey, data );
      }
      return data;
    };

    if(cachedData) {
      if(callback) {
        // Execute callback also if there is one
        callback(cachedData);
      }
      req.resolve(cachedData, 'cached');
    } else {
      req = request(method, dataType, url, _.extend(options, {
        dataFilter: onDataReceivedFilter
      }), callback);
    }

    return req;
  }

  // Ajax with the same signature as $.ajax, to keep it compatible
  function ajax(options) {
    var beforeSend = options.beforeSend;

    // Append default options
    options = _.extend(options, {
      traditional: false,
      beforeSend: function(xhr, request) {
        eventHandlers.onAjaxBeforeSend(xhr, request);
        if (_.isFunction(beforeSend)) {
          beforeSend(xhr, request);
        }
      }
    });

    return $.ajax(options);
  }

  podioEvent.bind(podioEvent.Types.init, onDomReady);
  podioEvent.bind(podioEvent.Types.unload, eventHandlers.onUnload);

  return {
    'request': request,
    'cachedRequest' : cachedRequest,
    'post': request.curry('post'),
    'postJSON': request.curry('post', 'json'),
    'get': request.curry('get'),
    'getJSON': request.curry('get', 'json'),
    'delete': request.curry('delete'),
    'deleteJSON': request.curry('delete', 'json'),
    'put': request.curry('put'),
    'putJSON': request.curry('put', 'json'),
    'requestFromElement': requestFromElement,
    'ajax': ajax
  };

});

